//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { LocationAddressInputItem } from './LocationAddressInputItem';
import { LocationAddressType } from './Enums';

export class BasicAddressInputItem extends LocationAddressInputItem {
    override readonly AddressType: LocationAddressType = LocationAddressType.BasicAddress;
    Address: string | null = null;

    constructor(initializer?: Partial<Omit<BasicAddressInputItem, "AddressType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "BasicAddressInputItem";
}
